import { useEffect, useState, useContext } from "react";
import { api } from "../App";
import Card from "./card";
import Loading from "./loading";

const Tags = ({ match }) => {
  const { apiData } = useContext(api);
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  useEffect(() => {
    const data = apiData.filter(
      (obj) =>
        obj.tags.find((tagObj) => tagObj.name === match.params.tag_id) !==
        undefined
    );
    setTags(data);
    if (!data.length && apiData.length) setLoading(false);
  }, [apiData, match.params]);

  useEffect(() => {
    if (tags.length && apiData.length) {
      setLoading(false);
    }
  }, [tags, apiData]);

  return loading ? (
    <Loading />
  ) : (
    <div className="api-data">
      {!!tags.length ? (
        tags.map((obj) => <Card obj={obj} key={obj.id} />)
      ) : (
        <p className="nothing">There is nothing coming up at this time.</p>
      )}
    </div>
  );
};

export default Tags;
